import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { PhUsersFour } from 'ember-phosphor-icons';
import Chip from 'tio-ui/components/chip';
import BenefitCard from 'tio-employee/components/dashboard-kit/benefit-card';
import type { ReviewerLoad } from 'tio-employee/utils/partner-dashboard/sources/approval-health';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** How many approvers the card lists before summarising the rest. */
const SHOWN = 8;

/** Pertinent card: who pending approvals are waiting on, heaviest first, flagging deactivated approvers. */
export default class ApproverWorkloadWidget extends Component<
  WidgetComponentSignature<ReviewerLoad[]>
> {
  get shown() {
    return this.args.data.slice(0, SHOWN);
  }

  get hiddenCount() {
    return Math.max(this.args.data.length - SHOWN, 0);
  }

  <template>
    <BenefitCard
      @title={{t "partner_dashboard.workload.title"}}
      @icon={{PhUsersFour}}
      data-test-partner-dashboard-approver-workload
    >
      {{#if this.shown.length}}
        <ul class="tio-col gap-3 pii" role="list">
          {{#each this.shown key="employeeId" as |reviewer|}}
            <li
              class="tio-row-between gap-3"
              data-test-partner-dashboard-approver={{reviewer.employeeId}}
            >
              <span class="tio-row-tight flex-wrap tio-fill-min">
                <span class="tio-text-base-semibold tio-fg-primary">
                  {{if reviewer.name reviewer.name (t "partner_dashboard.workload.external")}}
                </span>
                {{#if (eq reviewer.isActive false)}}
                  <Chip @intent="danger" @appearance="faded" @size="sm">
                    {{t "partner_dashboard.workload.deactivated"}}
                  </Chip>
                {{/if}}
              </span>
              <span class="shrink-0 tio-text-sm-medium tio-fg-secondary">
                {{t "partner_dashboard.workload.waiting" count=reviewer.pending}}
              </span>
            </li>
          {{/each}}
        </ul>
        {{#if this.hiddenCount}}
          <p class="tio-text-sm-medium tio-fg-secondary">
            {{t "partner_dashboard.workload.more" count=this.hiddenCount}}
          </p>
        {{/if}}
      {{else}}
        <p class="tio-text-sm-medium tio-fg-secondary">{{t "partner_dashboard.workload.empty"}}</p>
      {{/if}}
    </BenefitCard>
  </template>
}
